import { FormTheme, Widget } from '@kanda-libs/ks-component-ts';
import { BreakPoints, Text } from '@kanda-libs/ks-design-library';

import useCreateJobContextValue from 'pages/CreateJob/CreateJob-useCreateJobContextValue';
import useIsLeadJob from 'pages/CreateJob/CreateJob-useIsLeadJob';
import { FORM_THEME, TITLE_FIELD_PROPS } from './Title-constants';
import Container from './Title-container';

const ViewComponent = ({}) => {
  const isLeadJob = useIsLeadJob();
  const {
    data: { job },
  } = useCreateJobContextValue();

  const description = isLeadJob ? (
    <Text text={`Customer job description: ${job?.description}`} />
  ) : (
    <></>
  );

  return (
    <Container>
      {({ onBlur }) => (
        <BreakPoints
          mobile={
            <FormTheme variant={FORM_THEME.mobile}>
              <>
                <h2 className="text-style-f-em text-neutral-900">
                  {TITLE_FIELD_PROPS.mobile.label}
                </h2>
                <Widget.JobTitle
                  {...TITLE_FIELD_PROPS.mobile}
                  label=""
                  onBlur={onBlur}
                  className="!mb-2"
                />
                {description}
              </>
            </FormTheme>
          }
          desktop={
            <FormTheme variant={FORM_THEME.desktop}>
              <>
                <Widget.JobTitle
                  {...TITLE_FIELD_PROPS.desktop}
                  onBlur={onBlur}
                />
                {description}
              </>
            </FormTheme>
          }
        />
      )}
    </Container>
  );
};

ViewComponent.displayName = 'Title-view';

export default ViewComponent;
